<div class="obd-bg">
  <div class="obd-page">
    <div class="col-lg-12">
      <router-outlet></router-outlet>
    </div>
  </div>  
</div>

